angular
    .module("skillBuilderSaaS")
    .directive("onCarouselChange", ["$parse", function ($parse) {
        //http://stackoverflow.com/questions/24686119/how-do-you-bind-to-angular-uis-carousel-slide-events
        return {
            require: "uib-carousel",
            link: function (scope, _element, attrs, carouselCtrl) {
                var fn = $parse(attrs.onCarouselChange);
                var origSelect = carouselCtrl.select;
                carouselCtrl.select = function (nextSlide, direction) {
                    if (this.getCurrentIndex() !== undefined) {
                        if (nextSlide !== this.currentSlide) {
                            fn(scope, {
                                nextSlide: nextSlide,
                                direction: direction
                            });
                        }
                    }
                    return origSelect.apply(this, arguments);
                };
            }
        };
    }]);
